import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OutAdminProductDTO, OutAdminProductExtendedViewDTO } from "@app/api/generated";

export interface IProductsState {
  products?: OutAdminProductDTO[];
  selectedProduct?: OutAdminProductExtendedViewDTO;
  totalPages: number;
  totalResults: number;
  isLoading?: boolean;
}

const initialState: IProductsState = {
  products: [],
  totalPages: 1,
  totalResults: 0
};

export const slice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<OutAdminProductDTO[]>) => {
      state.products = action.payload;
    },
    setTotalResults: (state, action: PayloadAction<number>) => {
      state.totalResults = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSelectedProduct: (state, action: PayloadAction<OutAdminProductExtendedViewDTO | undefined>) => {
      state.selectedProduct = action.payload;
    },
    deleteProductFromList: (state, action: PayloadAction<number>) => {
      state.products = state.products?.filter((filter) => filter.id !== action.payload);
    },
    setTotalPages: (state, action: PayloadAction<number>) => {
      state.totalPages = action.payload;
    }
  }
});

export const productsActions = slice.actions;

export default slice.reducer;
